import { render, staticRenderFns } from "./TabKpi.vue?vue&type=template&id=18c0db7a"
import script from "./TabKpi.vue?vue&type=script&lang=js"
export * from "./TabKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports